import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';

import { AngularFireModule } from '@angular/fire';
import { AngularFireDatabaseModule } from '@angular/fire/database';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { AngularFireStorageModule } from '@angular/fire/storage';
import { environment } from '../environments/environment';
import { ElectService } from './service/elect.service';
import { VotingComponent } from './voting/voting.component';
import { LoginComponent } from './login/login.component';
import { WindowService } from './service/window.service';
import { VotesuccessComponent } from './votesuccess/votesuccess.component';
import { UnregvoterComponent } from './unregvoter/unregvoter.component';
import { VoterregComponent } from './voterreg/voterreg.component';
import { CountdownModule } from 'ngx-countdown';
import { VoterlistComponent } from './admin/voterlist/voterlist.component';
import { VotesComponent } from './admin/votes/votes.component';
import { AllvoterComponent } from './allvoter/allvoter.component';
import { ChartsModule } from 'ng2-charts';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    VotingComponent,
    LoginComponent,
    VotesuccessComponent,
    UnregvoterComponent,
    VoterregComponent,
    VoterlistComponent,
    VotesComponent,
    AllvoterComponent
  ],
  imports: [
    ChartsModule,
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFireDatabaseModule,
    AngularFireAuthModule,
    AngularFirestoreModule.enablePersistence(),
    AngularFireStorageModule,
    CountdownModule
  ],
  providers: [ElectService, WindowService, {
    provide: LocationStrategy,
    useClass: HashLocationStrategy}],
  bootstrap: [AppComponent]
})
export class AppModule { }
